const fields = {
  config: {
    columns: 1 },
  fields: [
    {
      name: "id",
      column: 1,
      type:"unvisible"
    },
    {
      name: "value",
      column: 1,
      type:"unvisible"
    },
    {
      name: "name",
      label: "Nazwa",
      column: 1,
      mandatory: true
    },

  ]


};

export default fields;